import { msalInstance } from "./msalInstance";

/**
 * Gets the logged in user's profile photo url from Microsoft Graph
 * @returns the logged in user's profile photo url
 */
export async function getProfilePhotoUrl(): Promise<string | undefined> {
    const endpoint = "https://graph.microsoft.com/v1.0/me/photo/$value";

    // get the logged in account
    const account = msalInstance.getAllAccounts()[0];

    // acquire a token silently with the User.Read scope
    const result = await msalInstance.acquireTokenSilent({
        account: account,
        scopes: ["User.Read"]
    });

    const response = await fetch(endpoint, {
        headers: {
            Authorization: `Bearer ${result.accessToken}`
        }
    });

    if (!response.ok) {
        return;
    }

    // Get the response as a Blob
    const pictureBlob = await response.blob();

    // Create a local URL for the blob
    const blobUrl = window.URL.createObjectURL(pictureBlob);

    return blobUrl;
}
